import {createReducer, createAction} from 'redux-act';
import {WizardOptionType, WizardTreeType, WizardValueType} from '@optimaxdev/wizard-ms';
import {AxiosResponse} from 'axios';
import {createSelector} from 'reselect';

import {getCustomerConfiguration} from 'features/wizardMs/reducers/customerConfiguration/customerConfiguration';
import {ApplicationStoreType} from 'reducers';
import {getWizard} from 'features/wizardMs/reducers/wizardData/wizardData';

export type ReadersNodeType = WizardOptionType & {error?: string};

export const initialState: ReadersNodeType = {
    alias: 'power',
    node: 0,
    type: 'option',
    items: [],
    error: '',
};

export const setReadersError = createAction<string, string>('SET_READERS_ERROR', error => error);

/**
 * readers reducer
 */
export const readers = createReducer<WizardOptionType>({}, initialState)
    /**
     * Subscribe actions
     * https://www.npmjs.com/package/redux-act#typescript
     */
    .on(
        `${getWizard}_FULFILLED`,
        (
            state: WizardOptionType,
            {data}: AxiosResponse<{tree: WizardTreeType}>,
        ): WizardOptionType => {
            const readersNode =
                data.tree.items.find(options => options.alias === 'power') || initialState;
            return {
                ...readersNode,
            };
        },
    )
    .on(
        `${setReadersError}`,
        (state: ReadersNodeType, error: string): ReadersNodeType => ({
            ...state,
            error,
        }),
    );
/**
 * Provides the readers node
 * @param {ApplicationStoreType} store - store
 * @returns {WizardOptionType} node
 */
export const getReadersNode = (store: ApplicationStoreType): ReadersNodeType =>
    store.wizardMs.readers;

/**
 * Provides the readers items
 * @param {ApplicationStoreType} store - store
 * @returns {WizardValueType[]} node items
 */
export const getReadersItems = createSelector(getReadersNode, (readersNode): WizardValueType[] =>
    (readersNode.items || [])
        .map(value => ({...value, parentNodeId: readersNode.node}))
        .sort((a, b) => a.sort - b.sort),
);

/**
 * Provides selected power node
 */
export const getActivePower = createSelector(
    getReadersNode,
    getCustomerConfiguration,
    (readersNode, configuration): WizardValueType | {} =>
        (readersNode.items || []).find(
            usageItem => usageItem.node === configuration.options[readersNode.node],
        ) || {},
);
